<div class="modal-header border-0">
  <div class="position-relative text-center">
    <span class="font-xl fw-bold uppercase"
          [translate]="'modal.reportMissingBakery.header'">Contact us</span>
  </div>
</div>
<div class="modal-body">
  <ui-message class="d-block mb-4"
              *ngIf="isSuccess"
              [type]="'success'">
    {{'modal.reportMissingBakery.sendMessageSuccess' | translate}}
  </ui-message>

  <form *ngIf="!isSuccess" [formGroup]="form">

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="font-xl fw-bold"
                 [translate]="'modal.contactUs.name'">Your name</label>
          <input class="form-control"
                 placeholder="{{'common.name' | translate}}..."
                 [maxlength]="'32'"
                 formControlName="userName">
        </div>
      </div>

      <div class="col-sm-6">
        <label class="font-xl fw-bold"
               [translate]="'modal.contactUs.email'">Email</label>
        <input class="form-control"
               [maxlength]="'128'"
               placeholder="{{'common.email' | translate}}..."
               [pattern]="EMAIL_PATTERN"
               formControlName="email"
        >
      </div>
    </div>


    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="font-xl fw-bold"
                 [translate]="'modal.reportMissingBakery.bakeryName'">Name of bakery</label>
          <input class="form-control"
                 placeholder="{{'modal.reportMissingBakery.bakeryNamePlaceholder' | translate}}..."
                 [maxlength]="'64'"
                 formControlName="bakeryName">
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="font-xl fw-bold"
                 [translate]="'modal.contactUs.city'">Your city</label>
          <input class="form-control"
                 placeholder="{{'modal.contactUs.cityPlaceholder' | translate}}..."
                 [maxlength]="'64'"
                 formControlName="city">
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="font-xl fw-bold"
             [translate]="'modal.contactUs.message'">Your massage</label>
      <textarea class="form-control" rows="4"
                placeholder="{{'modal.contactUs.messagePlaceholder' | translate}}..."
                [maxlength]="'512'"
                formControlName="message"></textarea>
    </div>

    <div class="text-end mt-2rem">
      <button class="btn btn-pink px-5"
              [disabled]="form.invalid"
              (click)="send()"
              [translate]="'common.send'">
        Send
      </button>
    </div>
  </form>
</div>
